module.exports = __webpack_public_path__ + "static/zuva-logo-b99dfd9ec858120e1996587f5d86e1a1.png";